var mobileWidth = 750;

$(function() {
  /********** Home Featured Collection **********/
  $('.featured-slideshow__wrapper').slick({
          dots: true,
        arrows: false,

  });
        	$('.shopify-section .page-width').not('#shopify-section-footer .page-width, #shopify-section-header .page-width,#shopify-section-collection .page-width,#shopify-section-text-content-with-side-image .page-width').attr('data-aos','fade-up');
     //$('.product-grid-container .card-wrapper').attr('data-aos','fade-up');
      AOS.init({
       offset: 120,
        delay: 300,
        duration: 600,
        easing: 'ease-in-out',
        once: true,
      });
  
  activateSlickOnMobile('.featured-collection','.collection');
  activateSlickOnMobile('.featured-articles','.template-index .blog-section-wrapper');

  // Prevent collection list from shifting when hovered due to added border
  $('[data-section-type="collections-list"]').on('mouseover', '.grid__item', function(e) {
    if($(window).width() > mobileWidth) {
      var $this = $(this);
      $this
        .prev()
        .find('.featured-card')
        .css('border-right-color','#c81322');

      $this
        .find('.featured-card')
        .css('border-color','#c81322');
    }
  });  

  $('[data-section-type="collections-list"]').on('mouseleave', '.grid__item', function(e) {
    if($(window).width() > mobileWidth) {
      var $this = $(this);

      $this
        .prev()
        .find('.featured-card')
        .css('border-right-color','#e1eaf4');
  
      $this
        .find('.featured-card')
        .css('border-color','#e1eaf4');
    }
  });

  // Hide parent element of hidden sections to remove remaining space
  $('.hidden-section').each(function(){
    $(this)
      .parent('.shopify-section')
      .hide();
  });

  /********** Home Blog List **********/
  dynamicRowHeightSetter('.article-block', '.article-block__title'); // Blog titles
  dynamicRowHeightSetter('.testimonials', '.rte-setting'); // Testimonials

  $(".excerpt-or-content").each(function() { //homepage and blogs page
    var $this = $(this);
    var txt = $this.text();
    if (txt.length > 130) {
      var shortText = txt.substring(0, 130);
      $this.text(shortText + '...');
    }
  });

  /********** Navigation **********/
  resizeNavMenus();

  // Search bar
  $('body').on('focus','#SiteNavSearch', function(e) {
    $('.site-header__search').addClass('input-focus');
  });
  $('body').on('blur','#SiteNavSearch', function(e) {
    $('.site-header__search').removeClass('input-focus');
  });

  // Search bar on mobile drawer
  $('body').on('focus','.drawer__search-input', function(e) {
    $('.drawer__search').addClass('input-focus');
  });
  $('body').on('blur','.drawer__search-input', function(e) {
    $('.drawer__search').removeClass('input-focus');
  });
  
  if($(window).width() > mobileWidth) {
    $('.site-header__search').addClass('active-form');
  }


  /********** Footer **********/
  $('.site-footer__section-title').on('click', function(e){
    if($(window).width() <= mobileWidth) {
      $(this)
        .closest('.site-footer__section')
        .toggleClass('active')
        .find('.second-level')
        .toggleClass('visible-mobile');
    }
  })
  $('body').on('click','.site-footer .second-level li', function(e) {
    if($(window).width() <= mobileWidth) {
      $(this)
        .find('a')[0]
        .click();
    }
  });

}); //end of onready

/********** Functions **********/

// Functions on resize
$(window).resize(
  $.debounce(50, function() {
    activateSlickOnMobile('.featured-collection', '.collection');
    activateSlickOnMobile('.featured-articles','.template-index .blog-section-wrapper');

    dynamicRowHeightSetter('.featured-articles', '.article-block__title'); // Blog titles
    dynamicRowHeightSetter('.testimonials', '.rte-setting'); // Testimonials

    resizeNavMenus();

    activateSearchInput();

    //Reset slick list height to show overflow texts
    setTimeout(function() {
      $('.quotes-slider .slick-list').height('auto');
    }, 500);
  })
);

function activateSlickOnMobile(parent, element) {
  if($(window).width() <= mobileWidth) {
    if(!$(element).hasClass('slick-initialized')) {

      // Remove grid layout
      $(element)
        .addClass('was-grid')
        .removeClass('grid grid--no-gutters grid--uniform');
      $(element + ' > div')
        .addClass('was-grid')
        .removeClass('grid__item');

      var prevArrow = `<?xml version="1.0" encoding="UTF-8"?>
        <svg class="arrow" width="37px" height="37px" viewBox="0 0 37 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
            <title>Group 13</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="HomeV3" transform="translate(-150.000000, -3351.000000)">
                    <g id="Group-11" transform="translate(0.000000, 1975.000000)">
                        <g id="Group-13" transform="translate(150.000000, 1376.000000)">
                            <circle id="Oval" fill="#C81322" cx="18.5" cy="18.5" r="18.5"></circle>
                            <g id="Arrow" transform="translate(17.500000, 19.500000) rotate(90.000000) translate(-17.500000, -19.500000) translate(10.000000, 15.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                <g id="Group" transform="translate(0.428571, -0.000000)">
                                    <polygon id="Path" points="6.69428044 8.66666667 7.50751081 7.88782858 13.1817662 2.4359717 11.5553094 0.750507667 6.69428044 5.42352646 1.83326321 0.750507667 0.206806373 2.4359717 5.8810618 7.88782858"></polygon>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>`;
    
    var nextArrow = `<?xml version="1.0" encoding="UTF-8"?>
      <svg class="arrow" width="37px" height="37px" viewBox="0 0 37 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->
          <title>Group 12</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="HomeV3" transform="translate(-1253.000000, -3351.000000)">
                  <g id="Group-11" transform="translate(0.000000, 1975.000000)">
                      <g id="Group-12" transform="translate(1253.000000, 1376.000000)">
                          <circle id="Oval" fill="#C81322" cx="18.5" cy="18.5" r="18.5"></circle>
                          <g id="Arrow" transform="translate(19.500000, 19.500000) scale(-1, 1) rotate(90.000000) translate(-19.500000, -19.500000) translate(12.000000, 15.000000)" fill="#FFFFFF" fill-rule="nonzero">
                              <g id="Group" transform="translate(0.428571, -0.000000)">
                                  <polygon id="Path" points="6.69428044 8.66666667 7.50751081 7.88782858 13.1817662 2.4359717 11.5553094 0.750507667 6.69428044 5.42352646 1.83326321 0.750507667 0.206806373 2.4359717 5.8810618 7.88782858"></polygon>
                              </g>
                          </g>
                      </g>
                  </g>
              </g>
          </g>
      </svg>`;

    if($(parent + ' .arrow').length == 0) {
      $(prevArrow).prependTo(parent + ' .custom-prev');
      $(nextArrow).appendTo(parent + ' .custom-next');
    }
      
    $(parent + ' .custom-next').on('click', function(e){
      $(element).slick('slickNext');
    });
    $(parent + ' .custom-prev').on('click', function(e){
      $(element).slick('slickPrev');
    });

      $(element).slick({
        arrows: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        lazyLoad: "anticipated",
        adaptiveHeight: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3000,
        accessibility: true
      });
    }

  } else {
    if($(element).hasClass('slick-initialized')) {

      // Return grid layout
      $(element + '.was-grid').addClass('grid grid--no-gutters grid--uniform');
      $(element + ' .was-grid').addClass('grid__item');

      $(element).slick('unslick');
    }
  }
}

// To make height of blog titles uniform
function dynamicRowHeightSetter(template, elemToFind){
  var $reccoList = $(template).find(elemToFind);
  var maxHeight = 0;

  // reset height before resize
  $($reccoList).each(function() {
    $(this).css('height','auto');
  });

  // find max height of entire row
  setTimeout(function() {
    $($reccoList).each(function() {
      if ($(this).outerHeight() > maxHeight) {
        maxHeight = $(this).outerHeight();
      }
    });

    // set max height of entire row
    $($reccoList).each(function() {
      if (maxHeight > 0) {
        $(this).css({"height": maxHeight.toString() + "px"});
      }
    });
  }, 1000);
}

// Activate search input on desktop where nav is non-sticky, deactivate otherwise
function activateSearchInput() {
  if($(window).width() <= mobileWidth) {
    $('.site-header__search').removeClass('active-form');
  } else {
    $('.site-header__upper .site-header__search').addClass('active-form');
  }
}

// Lengthen each nav menu to avoid shifting on hover
function resizeNavMenus() {
  if($(window).width() > mobileWidth) {
    $('.nav-bar .site-nav__item:visible, .site-header__cart:visible').each(function() {
      $(this).width('auto'); //reset width first
      var currentWidth = $(this).outerWidth();
      $(this).width(currentWidth + 5 + 'px');
    });
  }
}